module.exports = __webpack_public_path__ + "img/bg3.886f440b.png";